import { z } from 'zod';

export const formSchema = z.object({
  reportIdentifier: z.string().optional(),
  reportColumns: z.array(z.string()).optional(),
});

export type FormSchema = z.infer<typeof formSchema>